export default "__VITE_ASSET__BX5bS2nJ__"